"use client";

import { useState } from "react";
import { login } from "@/lib/api";

interface LoginPageProps {
  onLogin: (username: string) => void;
}

export function LoginPage({ onLogin }: LoginPageProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(username, password);
      onLogin(data.username);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Blad logowania");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0b1120] flex items-center justify-center">
      {/* Background gradient effect */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-blue-600/5 rounded-full blur-[100px]" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[300px] bg-blue-800/5 rounded-full blur-[80px]" />
      </div>

      <div className="relative z-10 w-full max-w-md px-6">
        <div className="glass rounded-2xl p-8 glow-blue">
          {/* Logo */}
          <div className="flex flex-col items-center mb-8">
            <div className="w-20 h-20 rounded-3xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center glow-blue mb-6 animate-border-glow border-2 border-blue-500/30">
              <span className="text-white font-bold text-3xl">H</span>
            </div>
            <h1 className="text-2xl font-bold gradient-text">Hitmark</h1>
            <p className="text-sm text-muted-foreground mt-1">
              Kalkulator Leasingu
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label
                htmlFor="username"
                className="block text-sm font-medium text-blue-300 mb-2"
              >
                Login
              </label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-3 rounded-xl bg-blue-500/8 border border-blue-500/20 text-blue-100 placeholder-blue-400/40 focus:outline-none focus:border-blue-500/50 focus:ring-1 focus:ring-blue-500/30 transition-smooth"
                placeholder="Nazwa uzytkownika"
                autoComplete="username"
                required
              />
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-blue-300 mb-2"
              >
                Haslo
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-xl bg-blue-500/8 border border-blue-500/20 text-blue-100 placeholder-blue-400/40 focus:outline-none focus:border-blue-500/50 focus:ring-1 focus:ring-blue-500/30 transition-smooth"
                placeholder="Haslo"
                autoComplete="current-password"
                required
              />
            </div>

            {error && (
              <div className="rounded-xl p-3 border border-red-500/30 bg-red-500/5">
                <p className="text-red-400 text-sm text-center">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-xl font-semibold text-sm bg-blue-600 text-white glow-blue transition-smooth hover:bg-blue-500 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading && <span className="spinner !w-4 !h-4" />}
              {loading ? "Logowanie..." : "Zaloguj sie"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
